import { UniquelyIdentifiable } from '../../../../models/protocols/uniquely-identifiable';
import { LookAheadItem } from '../search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';

export class CompaniesAndLocations implements LookAheadItem, UniquelyIdentifiable {
  lookUpKey: string;
  companyId: number;
  locationId: number;

  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return '';
  }

  getUniqueIdentifier(): string {
    return `${this.companyId}
      -${this.locationId}
      -${this.lookUpKey}`;
  }
}
